module.exports = fox._r("webcamjs/webcam.swf", __webpack_public_path__ + "_/_/_/_/bower_components/webcamjs/webcam.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/bower_components/webcamjs/webcam.swf
// module id = 345
// module chunks = 2